// extracted by mini-css-extract-plugin
module.exports = {"container":"X0vkL","boxWrapper":"_3KMR8"};